import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { Button } from 'components/shared';

export const TableContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  background: #fff;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 0; 
  box-shadow: none; 
  box-sizing: border-box;
`;

export const TableWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
  background: #fff;
  box-sizing: border-box;
  border-spacing: 0;
  border-width: 0; 
  padding: 0; 
  border-width: 0;
  table-layout: fixed;
`;

export const StyledThead = styled.thead`
`;

export const StyledTh = styled.th`
  padding: 0.25rem 0.5rem;
  text-align: left;
  vertical-align: middle;
  font-weight: bold;
  color: var(--color-primary);
  white-space: nowrap;
  user-select: none;
  border-top: 1px solid #bdbdbd;
  border-bottom: 1px solid #bdbdbd;
  border-right: 1px solid #bdbdbd;
  border-left: ${({ left }) => (left ? '1px solid #bdbdbd' : 'none')};
  background: rgba(128, 128, 128, 0.1);
  &:not(:nth-child(1)):not(:nth-child(2)) {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover .resizer {
    opacity: 1 !important;
  }
  &:hover {
    opacity: 1 !important;
  }
  .resizer.isResizing {
    background: var(--color-primary) !important;
    opacity: 1 !important;
  }
`;

export const StyledTbody = styled.tbody`
  background: #fff;
`;

export const StyledTr = styled.tr`
  border: none;
  background: #fff;
`;

export const StyledTd = styled.td`
  vertical-align: middle;
  min-width: ${({ minWidth }) => minWidth};
  background: #fff;
  transition: none;
  border-spacing: 0;
  height: 1.5rem;
`;

export const CellRelative = styled.div`
  position: relative;
`;

export const CellContent = styled.div`
  height: 2rem;
  display: flex;
  align-items: center;
  padding: 0 0.25rem;
  position: relative;
  cursor: text;
  border-radius: 0;
  background: transparent;
  color: ${({ red }) => (red ? '#ef4444' : 'inherit')};
  border-bottom: ${({ red }) => (red ? '1px solid #ef4444' : 'none')};
`;

export const EllipsisText = styled.div`
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EditIconWrapper = styled.div`
  position: absolute;
  right: 0.25rem;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.5;
  transition: opacity 0.2s;
  pointer-events: none;
`;

export const CellButtonGroup = styled.div`
  display: flex;
  gap: 0.25rem;
`;
export const StyledRemoveButton = styled(Button)`
  color: #000;
  height: 1.5rem;
  background-color: transparent;
  font-size: 16px;
`;
export const CheckboxHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
export const Hint = styled.span`
  margin-left: 8px;
  font-size: 0.85em;
  color: #888;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 2px 6px;
  white-space: nowrap;
  position: absolute;
  left: 110%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;
export const TopActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const ActionButton = styled.button`
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 0.4rem 1.2rem;
  font-weight: 500;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s;
  &:hover {
    background: #174ea6;
  }
`;

export const Resizer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 5px;
  background: rgba(0, 0, 0, 0.1);
  cursor: col-resize;
  user-select: none;
  touch-action: none;
  opacity: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
    background: rgba(0, 0, 0, 0.3);
  }

  &.isResizing {
    background: #3B82F6;
    opacity: 1;
  }

  &::before {
    content: '';
    position: absolute;
    left: -2px;
    right: -2px;
    top: 0;
    bottom: 0;
  }
`;

export const RescheduleTableContainer = styled.div`
  width: 100%;
  padding: 1rem;
`;

export const SpreadsheetContainer = styled.div`
  width: 100%;
  margin: 1rem 0;
  
  .Spreadsheet {
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    overflow: hidden;
  }
  
  .Spreadsheet__table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .Spreadsheet__header {
    background-color: #f9fafb;
    font-weight: 600;
    border-bottom: 2px solid #d1d5db;
  }
  
  .Spreadsheet__cell {
    border: 1px solid #e5e7eb;
    padding: 0.5rem;
    min-height: 2rem;
  }
  
  .checkbox-cell {
    text-align: center;
    cursor: pointer;
    user-select: none;
  }
  
  .error-cell {
    background-color: #fef2f2;
    border-color: #fca5a5;
    color: #dc2626;
  }
  
  .Spreadsheet__input {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    padding: 0.25rem;
  }
`;
